/**
 * 언어 관리 서비스 - 공유 라이브러리 버전
 * 정석 방법론: 확장 가능한 언어 감지 및 관리 시스템
 */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { I18N_LANG_KEY } from '@edusense/shared-constants';
// 기본 설정 - 각 앱에서 오버라이드 가능
export var DEFAULT_SUPPORTED_LANGUAGES = [
    'ko',
    'en',
    'ja'
];
export var DEFAULT_LANGUAGE = 'ko';
// 브라우저 언어 매핑
export var DEFAULT_BROWSER_LANGUAGE_MAP = {
    'ko': 'ko',
    'ko-KR': 'ko',
    'en': 'en',
    'en-US': 'en',
    'en-GB': 'en',
    'ja': 'ja',
    'ja-JP': 'ja'
};
// 언어 감지 설정
export var DEFAULT_LANGUAGE_DETECTION_CONFIG = {
    storageKey: I18N_LANG_KEY,
    fallbackLanguage: DEFAULT_LANGUAGE,
    enableBrowserDetection: true,
    enableUrlDetection: true
};
export var LanguageService = /*#__PURE__*/ function() {
    "use strict";
    function LanguageService() {
        _class_call_check(this, LanguageService);
    }
    _create_class(LanguageService, null, [
        {
            key: "configure",
            value: /**
   * 서비스 설정 업데이트 (각 앱에서 커스터마이징 가능)
   */ function configure(config) {
                this.config = _object_spread_props(_object_spread({}, this.config, config), {
                    detectionConfig: _object_spread({}, this.config.detectionConfig, config.detectionConfig)
                });
            }
        },
        {
            key: "getDefaultLanguage",
            value: /**
   * 기본 언어 감지 로직
   * 우선순위: localStorage > URL > 브라우저 > 기본값
   */ function getDefaultLanguage() {
                // 1순위: localStorage에서 저장된 언어 확인
                if (typeof window !== 'undefined') {
                    var savedLang = localStorage.getItem(this.config.detectionConfig.storageKey);
                    if (savedLang && this.isValidLanguage(savedLang)) {
                        return savedLang;
                    }
                }
                // 2순위: URL에서 언어 감지
                if (typeof window !== 'undefined' && this.config.detectionConfig.enableUrlDetection) {
                    var urlLang = this.extractLanguageFromUrl(window.location.pathname);
                    if (urlLang) {
                        return urlLang;
                    }
                }
                // 3순위: 브라우저 언어 감지
                if (typeof window !== 'undefined' && this.config.detectionConfig.enableBrowserDetection) {
                    var browserLang = this.getBrowserLanguage();
                    if (browserLang) {
                        return browserLang;
                    }
                }
                // 4순위: 기본값
                return this.config.detectionConfig.fallbackLanguage;
            }
        },
        {
            key: "extractLanguageFromUrl",
            value: /**
   * URL에서 언어 추출
   */ function extractLanguageFromUrl(pathname) {
                var langMatch = pathname.match(/^\/([a-z]{2})(?:\/|$)/);
                if (langMatch) {
                    var lang = langMatch[1];
                    return this.isValidLanguage(lang) ? lang : null;
                }
                return null;
            }
        },
        {
            key: "getBrowserLanguage",
            value: /**
   * 브라우저 언어 감지
   */ function getBrowserLanguage() {
                if (typeof window === 'undefined') return null;
                // navigator.language와 navigator.languages 확인
                var languages = [
                    navigator.language
                ].concat(_to_consumable_array(navigator.languages || []));
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = languages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var lang = _step.value;
                        // 정확한 매치 확인
                        if (this.config.browserLanguageMap[lang]) {
                            return this.config.browserLanguageMap[lang];
                        }
                        // 언어 코드만 추출하여 확인 (예: 'ko-KR' -> 'ko')
                        var langCode = lang.split('-')[0];
                        if (this.config.browserLanguageMap[langCode]) {
                            return this.config.browserLanguageMap[langCode];
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return null;
            }
        },
        {
            key: "isValidLanguage",
            value: /**
   * 유효한 언어인지 확인
   */ function isValidLanguage(lang) {
                return this.config.supportedLanguages.includes(lang);
            }
        },
        {
            key: "saveLanguage",
            value: /**
   * 언어를 localStorage에 저장
   */ function saveLanguage(lang) {
                if (typeof window !== 'undefined') {
                    localStorage.setItem(this.config.detectionConfig.storageKey, lang);
                }
            }
        },
        {
            key: "hasLanguagePrefix",
            value: /**
   * URL에서 언어 접두사 확인
   */ function hasLanguagePrefix(pathname) {
                var langPattern = new RegExp("^/(".concat(this.config.supportedLanguages.join('|'), ")(?:/|$)"));
                return langPattern.test(pathname);
            }
        },
        {
            key: "addLanguagePrefix",
            value: /**
   * URL에 언어 접두사 추가
   */ function addLanguagePrefix(pathname) {
                var search = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '', hash = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '', language = arguments.length > 3 ? arguments[3] : void 0;
                var lang = language || this.getDefaultLanguage();
                return "/".concat(lang).concat(pathname).concat(search).concat(hash);
            }
        },
        {
            key: "getSupportedLanguages",
            value: /**
   * 지원 언어 목록 반환
   */ function getSupportedLanguages() {
                return this.config.supportedLanguages;
            }
        },
        {
            key: "getDefaultLanguageStatic",
            value: /**
   * 기본 언어 반환
   */ function getDefaultLanguageStatic() {
                return this.config.defaultLanguage;
            }
        },
        {
            key: "getConfig",
            value: /**
   * 현재 설정 반환
   */ function getConfig() {
                return _object_spread({}, this.config);
            }
        }
    ]);
    return LanguageService;
}();
_define_property(LanguageService, "config", {
    supportedLanguages: DEFAULT_SUPPORTED_LANGUAGES,
    defaultLanguage: DEFAULT_LANGUAGE,
    browserLanguageMap: DEFAULT_BROWSER_LANGUAGE_MAP,
    detectionConfig: DEFAULT_LANGUAGE_DETECTION_CONFIG
});
